/* eslint-disable react-refresh/only-export-components */
import {
  ChartBarIcon,
  ChartSquareBarIcon,
  ClipboardCheckIcon,
  ClockIcon,
  CollectionIcon,
  CursorClickIcon,
  FlagIcon,
  HeartIcon,
  LinkIcon,
  PhotographIcon,
  SearchIcon,
  TableIcon,
  ViewListIcon,
} from "@heroicons/react/outline";
import { ComponentType } from "react";

import { classNames } from "@helpers/css";

type HeroIcon = ComponentType<{ className?: string }>;

const HeadingIcon = ({ level }: { level: 1 | 2 | 3 }) => (
  <span className="font-bold text-gray-500 text-xs leading-none w-4 text-center">
    H{level}
  </span>
);

const OrderedListIcon = ({ className }: { className?: string }) => (
  <span
    className={classNames(
      "font-semibold text-gray-500 text-xs leading-none w-4 text-center",
      className,
    )}
  >
    1.
  </span>
);

const wrap = (Icon: HeroIcon) =>
  function WrappedIcon() {
    return <Icon className="w-4 h-4 text-gray-500 shrink-0" />;
  };

export const icons = {
  actionItem: wrap(ClipboardCheckIcon),
  goal: wrap(FlagIcon),
  recognition: wrap(HeartIcon),
  kpi: wrap(ChartBarIcon),
  kpiGroup: wrap(ChartSquareBarIcon),
  button: wrap(CursorClickIcon),
  timer: wrap(ClockIcon),
  table: wrap(TableIcon),
  bulletList: wrap(ViewListIcon),
  orderedList: OrderedListIcon,
  embed: wrap(LinkIcon),
  giphy: wrap(PhotographIcon),
  find: wrap(SearchIcon),
  explorer: wrap(CollectionIcon),
  h1: () => <HeadingIcon level={1} />,
  h2: () => <HeadingIcon level={2} />,
  h3: () => <HeadingIcon level={3} />,
};
